export default __webpack_public_path__ + "static/media/contato.f7acbf43.jpg";